define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseModel = require("models/BaseModel");

    var BaseCollection = require("collections/BaseCollection");

    var KEYS = {
        ID: "id",
        IS_ENABLED: "isEnabled"
    };

    var PermissionModel = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {
        PermissionModel = BaseModel.extend({
            KEYS: KEYS,
            defaults: {
                id: null,
                isEnabled: false
            },

            initialize: function(attributes, options) {
                options = options || {};
                this._buildModel();

            },
            _buildModel: function() {
                this.unset();
            },
            getId: function() {
                return this.get(KEYS.ID);
            },
            isEnabled: function() {
                return this.get(KEYS.IS_ENABLED);
            },
            setIsEnabled: function(isEnabled) {
                this.valueIsChanged = true;
                this.set(KEYS.IS_ENABLED, isEnabled);
            },
            isValueChanged: function() {
                return this.valueIsChanged;
            }
        });
    }

    LE.module("LEUserManagement", moduleDefinition);


    return PermissionModel;
});
